"use client";

import { motion, useReducedMotion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa6";

const steps = [
  {
    title: "Share Your Website",
    description: "Tell us your URL, key services and main competitors.",
    icon: "M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1",
  },
  {
    title: "We Test AI Engines",
    description: "We run real customer questions across leading AI assistants.",
    icon: "M12 3l1.8 4.7L18.5 9l-4.7 1.8L12 15.5l-1.8-4.7L5.5 9l4.7-1.3z",
  },
  {
    title: "Get Your Report",
    description: "See where you're cited, where you're missing and why.",
    icon: "M14 3H6v18h12V7zM14 3v4h4M9 13h6M9 17h6",
  },
  {
    title: "Optimise & Track",
    description: "We implement fixes and track your AI visibility over time.",
    icon: "M3 17l6-6 4 4 8-8M14 7h7v7",
  },
];

export default function AiSearchProcess() {
  const reduceMotion = useReducedMotion();

  return (
    <motion.section
      initial={reduceMotion ? false : { opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: reduceMotion ? 0 : 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="bg-white px-4 pb-8 pt-12 sm:px-6 sm:pb-10 sm:pt-16 lg:px-8 dark:bg-gray-950"
    >
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-8">
        <div className="mx-auto flex max-w-2xl flex-col items-center gap-3 text-center">
          <p className="font-poppins text-sm font-bold uppercase tracking-widest text-pink-700 dark:text-pink-400">
            Our Process
          </p>
          <h2 className="font-poppins text-3xl font-bold text-indigo-950 sm:text-4xl dark:text-white">
            How It <span className="text-violet-700 dark:text-violet-400">Works</span>
          </h2>
          <p className="text-base text-slate-600 dark:text-slate-300">
            From your first audit to steady AI visibility, in four clear steps.
          </p>
        </div>

        <ol className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((step, index) => (
            <li
              key={step.title}
              className="relative flex flex-col items-center gap-3 text-center"
            >
              <span className="grid size-16 place-items-center rounded-full bg-pink-50 text-pink-700 ring-8 ring-pink-50/60 dark:bg-pink-950/50 dark:text-pink-300 dark:ring-pink-950/30">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                  className="size-6"
                >
                  <path d={step.icon} />
                </svg>
              </span>
              {index < steps.length - 1 && (
                <FaArrowRight
                  aria-hidden
                  className="absolute -right-5 top-5 hidden text-slate-300 lg:block dark:text-slate-600"
                />
              )}
              <h3 className="font-poppins text-base font-bold text-indigo-950 dark:text-white">
                {index + 1}. {step.title}
              </h3>
              <p className="max-w-56 text-sm leading-relaxed text-slate-600 dark:text-slate-300">
                {step.description}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </motion.section>
  );
}
